import { createContext } from 'react'

import { useProvideAuth } from 'config/firebase/auth'
import { useProvideFirestore } from 'config/firebase/firestore'
import { useProvideFunctions } from 'config/firebase/functions'

const FirebaseContext = createContext()

export const FirebaseProvider = ({ children }) => {
  const auth = useProvideAuth()
  const firestore = useProvideFirestore()
  const functions = useProvideFunctions()

  return (
    <FirebaseContext.Provider value={{ auth, firestore, functions }}>
      {!auth.loading && children}
    </FirebaseContext.Provider>
  )
}

export default FirebaseContext